import React from 'react';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { UiButton } from './ui';
import autoTable from 'jspdf-autotable';
import { toast } from "react-toastify";
import { instance } from "./axios";
import kjua from 'kjua';
//import './noto.js';



function generatePDF(data1, action, type, showLoader) {


  if (data1) {

    let doc = new jsPDF();


    const pageWidth = doc.internal.pageSize.getWidth();
    const centerX = pageWidth / 2;


    var datas = data1;
    if (!Array.isArray(data1)) {
      datas = [data1];

    } else {
      datas = datas.filter(obj => Object.keys(obj).length > 0);

    }
    datas.map((data, index) => {

      if (index > 0 && action == 'send') {
        doc = new jsPDF();
      }
      if (index > 0 && action == 'print') {
        doc.addPage();
      }


      const ledgerData = data.entries;


      var startY = 10;
      doc.setFontSize(12);

      doc.setFontSize(18);
      doc.text(data.company, centerX, startY, { align: 'center' });
      startY = startY + 10


      doc.setFontSize(16);
      doc.text(type == 'due_slip' ? 'Due Slip' : 'Ledger', centerX, startY, { align: 'center' });
      startY = startY + 6



      doc.setFontSize(11);
      doc.text(data.period, centerX, startY, { align: 'center' });

      startY = startY + 10

      doc.setFontSize(13);
      doc.text('Party: ' + data.party, 14, startY, { align: 'left' });
      //    startY = startY + 5
      doc.setFontSize(10);
      doc.setFont(undefined, 'bold')
      doc.text('Opening Balance: Rs. ' + data.opening_bal, 196, startY, { align: 'right' });
      startY = startY + 5
      doc.setFont(undefined, 'normal')
      var tableColumn = ["Date", "No.", "Particulars", "Debit (Rs.)", "Credit (Rs.)", "Balance (Rs.)"];

      if (type == 'due_slip') {
        tableColumn = ["Date", "Particulars", "Debit (Rs.)", "Credit (Rs.)"];

      }
      const tableRows = [];

      ledgerData.forEach((transaction) => {
        const partyName = transaction.account;
        const itemsText = transaction.items.map(item => {
          return `${item[0]} || ${item[1]}`; // Add space to align qty
        }).join('\n');

        const particulars = `${partyName} ${itemsText ? '\n' + itemsText : ''}`;
        if (type == 'due_slip') {
          tableRows.push([
            transaction.date,
            particulars,
            transaction.debit,
            transaction.credit,
          ]);
        } else {
          tableRows.push([
            transaction.date,
            transaction.num,
            particulars,
            transaction.debit,
            transaction.credit,
            transaction.balance
          ]);
        }

      });

      var column_style = {
        0: { cellWidth: 20 },  // Date column
        1: { cellWidth: 15 },  // Date column
        2: { cellWidth: 71 }, // Particulars column
        3: { cellWidth: 24, halign: 'right' }, // Amount column
        4: { cellWidth: 24, halign: 'right' }, // Amount column
        5: { cellWidth: 28, halign: 'right' }, // Amount column
      }
      if (type == 'due_slip') {
        tableRows.push([
          'Total: ',
          '',
          data.totals.debit,
          data.totals.credit,
        ]);


        column_style = {
          0: { cellWidth: 20 },  // Date column
          1: { cellWidth: 114 }, // Particulars column
          2: { cellWidth: 24, halign: 'right' }, // Amount column
          3: { cellWidth: 24, halign: 'right' }, // Amount column
        }
      } else {
        tableRows.push([
          'Total: ',
          '',
          '',
          data.totals.debit,
          data.totals.credit,
          ''
        ]);
      }




      autoTable(doc, {
        head: [tableColumn],
        body: tableRows,
        startY: startY,
        theme: 'grid',
        margin: { top: 20 },
        styles: {
          fontSize: 9,
          cellPadding: 1,
          fillColor: [255, 255, 255],
          overflow: 'linebreak',
        },
        columnStyles: column_style,
        headStyles: {
          fontStyle: 'bold',
          fillColor: [255, 255, 255],
          textColor: [0, 0, 0],
          lineWidth: 0.1,
          lineColor: [191, 191, 191],
          halign: 'left',
          valign: 'middle',

        },
        didParseCell: function (data) {

          if (data.section === 'body' && data.column.index === (type == 'due_slip' ? 1 : 2)) {
            const doc = data.doc;
            const lines = data.cell.raw.split('\n');
            const cellWidth = type == 'due_slip' ? 114 : 71;

            data.cell.text = lines.map(line => {
              const [desc, qty] = line.split('||');

              if (qty !== undefined) {
                // Trim text to avoid extra spaces
                const descText = desc.trim();
                const qtyText = qty.trim();

                // Get the width of each text
                const descWidth = doc.getTextWidth(descText);
                const qtyWidth = doc.getTextWidth(qtyText);

                // Calculate available width in the cell
                const availableWidth = cellWidth - qtyWidth;


                // Adjust padding to align description and quantity
                const padding = Math.max(0, availableWidth - descWidth);

                // Create the formatted line with padding
                return `${descText}${' '.repeat(Math.floor(padding))}${qtyText}`;
              } else {
                // Return line if there's no quantity
                return line;
              }
            });
          }

          const isLastRow = data.row.index === data.table.body.length - 1;

          if (isLastRow) {
            // Merge the first and second columns in the last row
            if (data.column.index === 0) {
              data.cell.colSpan = type == 'due_slip' ? 2 : 3; // Set colspan to merge with the next column
            }

            // Set the content to be centered within the merged cell
            data.cell.styles.halign = 'right';
          }
        },


        pageBreak: 'auto',
      });

      doc.setFontSize(11);
      doc.setFont(undefined, 'bold')
      doc.text('Closing Balance: Rs. ' + data.totals.balance, 196, doc.lastAutoTable.finalY + 7, { align: 'right' });
      startY = startY + 5
      doc.setFont(undefined, 'normal')
      if(type == 'due_slip' && data.notes){
        
       
      
        //doc.setFont('MANGAL', 'normal');
        doc.setFontSize(10);
        doc.text(data.notes, 14, doc.lastAutoTable.finalY + 15, { align: 'left' });
      }

      if(type == 'due_slip' && data.upi) {
        const qrCode = kjua({
          text: data.upi_url,
          size: 128,
          render: 'image', // 'image', 'canvas', or 'svg'
        });
      
        // Get the QR code data URL
        const qrCodeDataUrl = qrCode.src;
        doc.addImage(qrCodeDataUrl, 'PNG', 14, doc.lastAutoTable.finalY + 20, 30, 30); // x, y, width, height
        doc.setFontSize(8);
        doc.text(data.upi, 14, doc.lastAutoTable.finalY + 53, { align: 'left' });
      }
      if (action == 'send') {
        showLoader(true)
        const pdfBlob = doc.output('blob');

        // Prepare the form data
        const formData = new FormData();
        formData.append('file', pdfBlob, 'report.pdf');
        formData.append('id', data.id);
        formData.append('type', type);



        instance({
          method: "post",
          url: "/send_ledger",
          data: formData,
        })
          .then(function (response) {
            showLoader(false)
            if (response.data.status == 'success') {
              toast(response.data.msg, { type: "success" });
            }
            if (response.data.status == 'error') {
              toast(response.data.msg, { type: "error" });
            }

          })
          .catch(function (response) { });
      }
    })
    //doc.save("ledger.pdf");

    if (action == 'print') {
      window.open(doc.output('bloburl', 'ledger.pdf'), '_blank');
    }

  }
};

export default generatePDF;
